/** Promotion usage fields from BigCommerce v2 coupons and v3 automatic promotions. */
export interface PromotionUsageFields {
  current_uses?: number;
  num_uses?: number;
  uses_count?: number;
  usage_count?: number;
  uses?: number;
  max_uses?: number | null;
  max_uses_per_customer?: number | null;
  max_uses_per_order?: number | null;
}

/**
 * Resolve the current usage count from a promotion or coupon record.
 * v3 automatic promotions use `current_uses`; v2 coupons use `num_uses`.
 */
export function getPromotionUseCount(promotion: PromotionUsageFields): number {
  const value =
    promotion.current_uses ??
    promotion.num_uses ??
    promotion.uses_count ??
    promotion.usage_count ??
    promotion.uses;

  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

/**
 * Resolve the maximum allowed uses, or null when unlimited.
 */
export function getPromotionMaxUses(promotion: PromotionUsageFields): number | null {
  const value =
    promotion.max_uses ??
    promotion.max_uses_per_customer ??
    promotion.max_uses_per_order ??
    null;

  if (value === null || value === undefined || value === 0) {
    return null;
  }

  return value;
}

/** Format usage as "current/max" or "current/Unlimited" (matches BigCommerce admin). */
export function formatPromotionUses(promotion: PromotionUsageFields): string {
  const numUses = getPromotionUseCount(promotion);
  const maxUses = getPromotionMaxUses(promotion);

  if (maxUses === null) {
    return `${numUses}/Unlimited`;
  }

  return `${numUses}/${maxUses}`;
}
